import React from 'react';
import { useLocation } from 'react-router-dom';

interface BreadcrumbSchemaProps {
  baseUrl?: string;
}

const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({
  baseUrl = "https://fownd.care"
}) => {
  const location = useLocation();

  const generateBreadcrumbSchema = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    
    // Don't generate schema for home page
    if (pathSegments.length === 0) {
      return null;
    }

    const breadcrumbs = [
      { name: 'Home', url: baseUrl }
    ];

    // Define route mappings for better names
    const routeLabels: Record<string, string> = {
      'notation': 'Notation Platform',
      'roi-calculator': 'ROI Calculator',
      'detailed-roi-calculator': 'Detailed ROI Calculator',
      'blogs': 'Blogs',
      'about': 'About Us',
      'contact': 'Contact',
      'demo': 'Demo',
      'privacy-policy': 'Privacy Policy',
      'terms-conditions': 'Terms & Conditions',
      'cookie-policy': 'Cookie Policy',
      'documentation-physical-therapy': 'The Power of Documentation in Physical Therapy',
      'advocacy-reimbursement': 'Fownd\'s Vision For Advocacy and Higher Reimbursement',
      'ai-healthcare-bias': 'AI in Healthcare: Tackling Bias for Better Care',
      'session-wrote-note': 'What If the Session Wrote the Note?',
      'proving-outcomes-future-pt': 'Proving Outcomes Is the Future of PT — Are We Ready?',
      'why-not-pt-first': 'Why Not PT First? Rethinking MSK care at the front door',
      'ai-soap-notes-pt-guide-2025': 'AI for SOAP Notes: Everything a PT Should Know in 2025'
    };

    let currentPath = '';
    pathSegments.forEach((segment) => {
      currentPath += `/${segment}`;
      breadcrumbs.push({
        name: routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '),
        url: `${baseUrl}${currentPath}`
      });
    });

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbs.map((crumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": crumb.name,
        "item": {
          "@type": "WebPage",
          "@id": crumb.url,
          "url": crumb.url
        }
      }))
    };

    return schema;
  };

  const schema = generateBreadcrumbSchema();

  if (!schema) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema)
      }}
    />
  );
};

export default BreadcrumbSchema; 